/*
  CUSTOM: product page info A/B test (PR.4 to PR.7 from the CRO review), each part with its own switch in the theme
  settings ("Product page info (A/B test)"). Markup, rendered from snippets/product-template.liquid:
  - PR.4 size field and size list: snippets/pdp-size-field.liquid, snippets/pdp-size-sheet.liquid
  - PR.5 "Læs mere om produktet": the button in snippets/product-template.liquid, snippets/pdp-info-panel.liquid
  - PR.6 sticky buy bar: snippets/pdp-sticky-buy.liquid
  - PR.7 offer popup after adding to cart: snippets/pdp-offer-popup.liquid, opened from eventAddToCart in
    assets/theme-custom.js through window.pdpOfferPopup
  Styles: assets/pdp-information.css

  The size list does not add to the cart itself: it chooses the size in the theme's own size buttons (hidden), so the
  theme keeps price, preorder fields, stock line and buy button up to date, and the buy button adds as before.
  On phones it is a bottom sheet; from 769px a dropdown from the size field (or above the sticky bar, from there).
*/
(function () {
  'use strict';

  var $section = document.querySelector('.product-section[data-pdp-ab]');
  if (!$section) return;

  var $overlays = $section.querySelector('.pdp-ab-overlays');
  var $config = $overlays && $overlays.querySelector('[data-pdp-config]');
  var $variantJson = $section.querySelector('[data-variant-json]');
  if (!$overlays || !$config || !$variantJson) return;

  var config = JSON.parse($config.textContent);
  var variants = JSON.parse($variantJson.value || $variantJson.textContent);
  var $form = $section.querySelector('[data-product-blocks] form.product-single__form');
  var root = document.documentElement;
  var isGerman = (root.lang || '').toLowerCase().indexOf('de') === 0;

  // the sheets and the bar live in <body>, so nothing on the page can clip or cover them
  var $scrim = $overlays.querySelector('[data-pdp-scrim]');
  Array.prototype.slice.call($overlays.children).forEach(function ($el) {
    if ($el !== $config) document.body.appendChild($el);
  });

  var sizeList = $section.classList.contains('pdp-size-list');
  var $rows = Array.prototype.slice.call(document.querySelectorAll('[data-pdp-size-row]'));
  var $sticky = document.querySelector('[data-pdp-sticky]');
  // the bar's own buttons (the size dropdown can hang in the bar too, with its own)
  var $stickyButtons = $sticky ? Array.prototype.slice.call($sticky.querySelectorAll('button')) : [];
  var $sizeSelect = $section.querySelector('.pdp-size__select');
  var $sizeField = $sizeSelect && $sizeSelect.querySelector('[data-pdp-size-open]');
  var $offer = document.querySelector('[data-pdp-sheet="offer"]');
  var $info = document.querySelector('[data-pdp-sheet="info"]');

  var current = byId(config.variantId);
  // PR.4: no size is chosen beforehand, unless the link names one (?variant=) or there is only one size
  var picked = !sizeList || /[?&]variant=/.test(window.location.search) || $rows.length === 1;

  function byId(id) {
    id = Number(id);
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].id === id) return variants[i];
    }
    return null;
  }

  function money(cents) {
    var text = window.theme && theme.Currency && theme.settings
      ? theme.Currency.formatMoney(cents, theme.settings.moneyFormat)
      : (cents / 100).toFixed(2);
    // the shop's money format wraps the amount in <span class=money>
    text = text.replace(/<[^>]*>/g, '');
    // as snippets/format-money.liquid
    if ((root.lang || '').indexOf('nb') === 0) text = text.replace(/\./g, ' ');
    return text;
  }

  function escapeHtml(text) {
    return String(text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  // the same rule as the theme's buy button (updateCartButton in assets/theme.js)
  function isPreorder(variant) {
    return !!(variant && variant.available && variant.preorder_confirm && !variant.warehouse_goods);
  }

  function rowFor(variant) {
    if (!variant) return null;
    for (var i = 0; i < $rows.length; i++) {
      if (Number($rows[i].dataset.variantId) === variant.id) return $rows[i];
    }
    return null;
  }

  /* ---------------------------------------------------------------------------------------------
     PR.4 size status: in stock, few left, preorder with month, sold out
  --------------------------------------------------------------------------------------------- */

  // the size's expected delivery as shown ("start november"; German keeps its capitals)
  function etaOf(variant) {
    var eta = String(variant.preorder_eta || '').replace(/\s+/g, ' ').trim();
    return isGerman ? eta : eta.toLowerCase();
  }

  function statusOf(variant) {
    if (!variant) return null;

    if (!variant.available) {
      return {
        key: 'so',
        html: escapeHtml(config.soldOut) + (config.notify ? ' · <u>' + escapeHtml(config.notify) + '</u>' : '')
      };
    }

    if (isPreorder(variant)) {
      var eta = etaOf(variant);
      var text = eta && config.preorderText ? config.preorderText.replace('[month]', eta) : config.preorderShort;
      return { key: 'pre', html: escapeHtml(text) };
    }

    var $row = rowFor(variant);
    var qty = $row ? Number($row.dataset.qty) : 0;
    if ($row && $row.hasAttribute('data-tracked') && qty > 0 && qty <= Number(config.lowStock)) {
      return { key: 'low', html: escapeHtml(config.lowStockText.replace('[count]', qty)) };
    }

    return { key: 'ok', html: escapeHtml(config.inStock) };
  }

  function paintStatus($status, status) {
    if (!$status) return;
    $status.hidden = !status;
    if (!status) return;
    $status.className = 'pdp-status pdp-status--' + status.key;
    $status.querySelector('span').innerHTML = status.html;
  }

  function renderSize() {
    $rows.forEach(function ($row) {
      var variant = byId($row.dataset.variantId);
      paintStatus($row.querySelector('[data-pdp-row-status]'), statusOf(variant));
      var active = picked && current && variant && variant.id === current.id;
      $row.classList.toggle('is-active', !!active);
      $row.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    var $value = document.querySelector('[data-pdp-size-value]');
    if ($value) {
      $value.textContent = picked && current ? current.option1 : config.chooseSize;
      $value.classList.toggle('is-empty', !(picked && current));
      paintStatus(document.querySelector('[data-pdp-size-status]'), picked ? statusOf(current) : null);
    }

    // before a size is chosen the buy button says "Vælg størrelse" and opens the list; once chosen, the theme
    // sets its label (Læg i kurv / Forudbestil / Udsolgt) on the size change
    if (sizeList && !picked && current && current.available && $form) {
      var $label = $form.querySelector('[data-add-to-cart-text]');
      if ($label) $label.textContent = config.chooseSize;
    }

    // the preorder badge on the images, for the chosen size (not when the theme's own label is there: every size
    // of the product is preorder, snippets/product-images.liquid)
    var $badge = $section.querySelector('[data-pdp-preorder-badge]');
    if ($badge) {
      var preorder = picked && isPreorder(current) && !config.preorderInfo && !$section.querySelector('.product__photos .product-preorder');
      $badge.hidden = !preorder;
      if (preorder) $badge.textContent = statusOf(current).html.replace(/&amp;/g, '&');
    }
  }

  // PR.4: the info icon in the info box's delivery row (a preorder size) opens the preorder text, as "Læs mere"
  document.addEventListener('click', function (e) {
    var $open = e.target.closest ? e.target.closest('[data-pdp-preorder-open]') : null;
    if ($open) openSheet('preorder', $open);
  });

  // chooses the size in the theme's own (hidden) size buttons; the theme does the rest
  function pickVariant(variant) {
    if (!variant) return;
    var $inputs = $section.querySelectorAll('.pdp-size-buttons [data-variant-input]');
    for (var i = 0; i < $inputs.length; i++) {
      if ($inputs[i].value === variant.option1) {
        picked = true;
        current = variant;
        $inputs[i].checked = true;
        $inputs[i].dispatchEvent(new Event('change', { bubbles: true }));
        break;
      }
    }
    render();
  }

  /* ---------------------------------------------------------------------------------------------
     Sheets: size list (PR.4), info panel (PR.5), offer popup (PR.7)
  --------------------------------------------------------------------------------------------- */

  var openName = null;
  var $opener = null;
  // the size list was opened by the sticky bar's buy button: the chosen size goes straight into the cart
  var addAfterPick = false;
  // from 769px the size list is a dropdown: by the size field, or in the sticky bar when opened there
  var wide = window.matchMedia('(min-width: 769px)');
  var $dropHost = null;

  function sheet(name) {
    return document.querySelector('[data-pdp-sheet="' + name + '"]');
  }

  function setExpanded(on) {
    document.querySelectorAll('[data-pdp-size-open]').forEach(function ($button) {
      $button.setAttribute('aria-expanded', on ? 'true' : 'false');
    });
  }

  function openSheet(name, $from) {
    var $sheet = sheet(name);
    if (!$sheet) return false;
    if (openName && openName !== name) closeSheet(true);

    if (name === 'size') {
      setExpanded(true);
      if (wide.matches && $sizeSelect) return openDrop($sheet, $from);
      // back from a dropdown, when the window was wider before
      if ($sheet.parentNode !== document.body) document.body.appendChild($sheet);
      $sheet.setAttribute('role', 'dialog');
      $sheet.setAttribute('aria-modal', 'true');
    }

    openName = name;
    $opener = $from || document.activeElement;
    root.classList.add('pdp-sheet-open');
    $scrim.classList.add('is-open');
    $sheet.classList.add('is-open');
    syncSticky();
    setTimeout(function () {
      try { $sheet.focus({ preventScroll: true }); } catch (e) { $sheet.focus(); }
    }, 60);
    return true;
  }

  // PR.4 from 769px: no sheet, but a dropdown from the size field, as a select's list. Opened from the sticky bar
  // (the field is out of view then), it rises from the bar by the button that opened it.
  // No scrim and no scroll lock: a click elsewhere, Tab, Escape or the field itself closes it.
  function openDrop($sheet, $from) {
    var $bar = $sticky && $from && $sticky.contains($from) ? $sticky : null;
    var $host = $bar || $sizeSelect;
    if ($dropHost && $dropHost !== $host) $dropHost.classList.remove('has-drop');
    if ($sheet.parentNode !== $host) $host.appendChild($sheet);
    $sheet.setAttribute('role', 'group');
    $sheet.removeAttribute('aria-modal');

    openName = 'size';
    // the list by the field belongs to the field, also when the page's buy button opened it
    $opener = $bar ? $from : $sizeField;
    $dropHost = $host;
    $host.classList.add('has-drop');
    root.classList.add('pdp-drop-open');
    placeDrop();
    // read the layout once, so the opening transition starts from the place just set (also after a move)
    void $sheet.offsetWidth;
    $sheet.classList.add('is-open');
    syncSticky();
    setTimeout(function () {
      try { $sheet.focus({ preventScroll: true }); } catch (e) { $sheet.focus(); }
    }, 60);
    return true;
  }

  // As a select: under the field when the list fits there, otherwise on the side with more room (up, near the bottom
  // of the window), never moving the page. In the sticky bar always up, from the left edge of the button that opened
  // it, or up to the right edge of one on the right. Taller than the room it has, the list scrolls.
  function placeDrop() {
    var $sheet = sheet('size');
    $sheet.style.left = '';
    $sheet.style.right = '';
    $sheet.style.maxHeight = '';
    if (!$dropHost || !$opener) return;

    var edge = 8;
    var at = $opener.getBoundingClientRect();
    var height = $sheet.offsetHeight;
    var up = true;
    var room;

    if ($dropHost === $sticky) {
      var bar = $sticky.getBoundingClientRect();
      room = bar.top - edge;
      if (at.left + at.width / 2 > bar.left + bar.width / 2) {
        $sheet.style.right = Math.max(bar.right - at.right, 0) + 'px';
      } else {
        $sheet.style.left = Math.max(at.left - bar.left, 0) + 'px';
      }
    } else {
      var below = window.innerHeight - at.bottom - edge;
      var above = at.top - edge;
      up = height > below && above > below;
      room = up ? above : below;
    }

    $dropHost.classList.toggle('is-up', up);
    if (height > room) $sheet.style.maxHeight = Math.max(room, 120) + 'px';
  }

  // leaveFocus: the customer clicked or tabbed elsewhere, so the focus stays there
  function closeSheet(switching, leaveFocus) {
    if (!openName) return;
    if (openName === 'size') {
      addAfterPick = false;
      setExpanded(false);
    }
    var $sheet = sheet(openName);
    if ($sheet) $sheet.classList.remove('is-open');
    openName = null;

    if ($dropHost) {
      $dropHost.classList.remove('has-drop');
      root.classList.remove('pdp-drop-open');
      $dropHost = null;
    }

    if (!switching) {
      $scrim.classList.remove('is-open');
      root.classList.remove('pdp-sheet-open');
      if (!leaveFocus && $opener && $opener.focus && document.body.contains($opener)) {
        try { $opener.focus({ preventScroll: true }); } catch (e) { /* not focusable */ }
      }
    }
    syncSticky();
  }

  // the offer popup's × and the scrim behind it go on to the cart, as "Fortsæt til kurv" does
  function dismiss() {
    var wasOffer = openName === 'offer';
    closeSheet();
    if (wasOffer) openCart();
  }

  $scrim.addEventListener('click', dismiss);
  // Escape only closes: the theme closes its drawer when the Escape key comes up again
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openName) closeSheet();
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-pdp-close]')) closeSheet();
  });

  /* PR.4 size list ------------------------------------------------------------------------------ */

  if (sizeList) {
    var $sizeSheet = sheet('size');

    document.addEventListener('click', function (e) {
      var $target = e.target.closest ? e.target.closest('[data-pdp-size-open], [data-pdp-size-row]') : null;
      if (!$target) return;

      if ($target.hasAttribute('data-pdp-size-open')) {
        // as a select: the field closes its open dropdown again
        if ($dropHost && $opener === $target) {
          closeSheet();
          return;
        }
        addAfterPick = false;
        openSheet('size', $target);
        return;
      }

      var variant = byId($target.dataset.variantId);
      if (!variant) return;
      if (!variant.available) {
        // a sold out size: choosing it opens the theme's back-in-stock form (assets/theme-custom.js, variant:change)
        closeSheet();
        pickVariant(variant);
        return;
      }
      var thenAdd = addAfterPick;
      pickVariant(variant);
      // the sheet stays a moment to show the choice; the dropdown closes at once, as a select's list
      setTimeout(function () {
        closeSheet();
        // from the sticky bar's "Læg i kurv": add it now, as the button promised (the offer popup follows, PR.7)
        if (thenAdd) setTimeout(addToCart, 120);
      }, $dropHost ? 0 : 180);
    });

    // the dropdown closes on a click outside it (its field and the bar's buttons close or move it themselves)...
    document.addEventListener('pointerdown', function (e) {
      if ($dropHost && !$dropHost.contains(e.target)) closeSheet(false, true);
    }, true);

    // ...and when Tab leaves it
    $sizeSheet.addEventListener('focusout', function (e) {
      if ($dropHost && e.relatedTarget && !$dropHost.contains(e.relatedTarget)) closeSheet(false, true);
    });

    // up and down go through the sizes, as in a select's list
    $sizeSheet.addEventListener('keydown', function (e) {
      var step = e.key === 'ArrowDown' ? 1 : e.key === 'ArrowUp' ? -1 : 0;
      if (!step || !$rows.length) return;
      e.preventDefault();
      var i = $rows.indexOf(document.activeElement);
      if (i === -1) i = step > 0 ? -1 : $rows.length;
      $rows[Math.min(Math.max(i + step, 0), $rows.length - 1)].focus();
    });

    // across 769px an open list closes, to open the other way next time
    var onWide = function () {
      if (openName === 'size') closeSheet(false, true);
    };
    if (wide.addEventListener) wide.addEventListener('change', onWide); else wide.addListener(onWide);
    window.addEventListener('resize', function () {
      if ($dropHost) placeDrop();
    });

    // the buy button before a size is chosen opens the list instead of adding (capture: before the cart code)
    document.addEventListener('click', function (e) {
      if (picked || !$form) return;
      var $button = e.target.closest ? e.target.closest('[data-add-to-cart]') : null;
      if (!$button || !$form.contains($button)) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      openSheet('size', $button);
    }, true);
  }

  // Størrelsesguide: the theme's own size guide (snippets/size-guide-selector.liquid), when the product has one
  var $themeGuide = document.querySelector('.size-selector-open-js');
  document.querySelectorAll('[data-pdp-size-guide]').forEach(function ($guide) {
    if (!$themeGuide) return;
    $guide.hidden = false;
    $guide.addEventListener('click', function () {
      closeSheet();
      $themeGuide.click();
    });
  });

  /* PR.5 info panel ----------------------------------------------------------------------------- */

  function setTab(key) {
    if (!$info) return;
    $info.querySelectorAll('[data-pdp-tab]').forEach(function ($tab) {
      var on = $tab.dataset.pdpTab === key;
      $tab.classList.toggle('is-active', on);
      $tab.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    $info.querySelectorAll('[data-pdp-pane]').forEach(function ($pane) {
      $pane.classList.toggle('is-active', $pane.dataset.pdpPane === key);
    });
    var $panes = $info.querySelector('.pdp-info__panes');
    if ($panes) $panes.scrollTop = 0;
  }

  // on a computer "Læs mere om produktet" opens no pop-up: the page goes down to the product's own "Om produktet"
  // accordion (the description) and opens it. False when the page has no such accordion; the pop-up opens then.
  function showDescriptionTab() {
    var $description = $section.querySelector('.collapsible-content .product-single__description');
    var $content = $description && $description.closest('.collapsible-content');
    var $trigger = $content && $content.id && $section.querySelector('[aria-controls="' + $content.id + '"]');
    if (!$trigger) return false;
    if (!$trigger.classList.contains('is-open')) $trigger.click();
    // clear of the header, which stays at the top while scrolling
    var $header = document.querySelector('.site-header');
    var top = $trigger.getBoundingClientRect().top + window.pageYOffset - ($header ? $header.offsetHeight : 0) - 16;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    return true;
  }

  if ($info) {
    setTab($info.dataset.firstTab);

    $info.addEventListener('click', function (e) {
      var $tab = e.target.closest('[data-pdp-tab]');
      if ($tab) setTab($tab.dataset.pdpTab);
    });

    document.addEventListener('click', function (e) {
      var $open = e.target.closest ? e.target.closest('[data-pdp-info-open]') : null;
      if (!$open) return;
      if (wide.matches) {
        // the size list's dropdown (its "Læs mere" link) closes first
        if (openName) closeSheet();
        if (showDescriptionTab()) return;
      }
      setTab($info.dataset.firstTab);
      if (openName === 'size') {
        // from the size list: let it slide away first
        closeSheet();
        setTimeout(function () { openSheet('info', $open); }, 250);
      } else {
        openSheet('info', $open);
      }
    });

    // FAQ stored as text holding JSON: listed here, as sections/product-faq.liquid does
    var $faqJson = $info.querySelector('[data-pdp-faq-json]');
    var $faqList = $info.querySelector('[data-pdp-faq-list]');
    if ($faqJson && $faqList) {
      try {
        var faq = JSON.parse($faqJson.textContent.trim());
        if (typeof faq === 'string') faq = JSON.parse(faq);
        if (Array.isArray(faq)) {
          $faqList.innerHTML = faq.map(function (item) {
            var question = item.q || item.Q || item.question || '';
            var answer = item.a || item.A || item.answer || '';
            if (!question) return '';
            return '<details><summary>' + escapeHtml(question) +
              '<svg aria-hidden="true" focusable="false" viewBox="0 0 12 8"><path d="M1 1l5 5 5-5"/></svg></summary>' +
              '<div class="pdp-info__answer">' + escapeHtml(answer).replace(/\n/g, '<br>') + '</div></details>';
          }).join('');
        }
      } catch (e) { /* not JSON: leave the FAQ to the section further down */ }
    }

    // without any FAQ (and no preorder question) the tab goes
    var $faqPane = $info.querySelector('[data-pdp-pane="faq"]');
    if ($faqPane && !$faqPane.querySelector('details')) {
      $faqPane.remove();
      var $faqTab = $info.querySelector('[data-pdp-tab="faq"]');
      if ($faqTab) $faqTab.remove();
      if ($info.dataset.firstTab === 'faq') {
        var $firstTab = $info.querySelector('[data-pdp-tab]');
        $info.dataset.firstTab = $firstTab ? $firstTab.dataset.pdpTab : '';
        setTab($info.dataset.firstTab);
      }
    }
  }

  // no panel (no content at all): no button
  if (!$info || !$info.querySelector('[data-pdp-tab]')) {
    document.querySelectorAll('[data-pdp-info-open]').forEach(function ($button) {
      var $block = $button.closest('.pdp-more-block');
      ($block || $button).hidden = true;
    });
  }

  // the theme's "Er nu tilføjet til kurven" shows on the buy button (assets/pdp-information.css); the tick only with
  // that text, not with the cart's error messages, which come in the same place. On the button it goes after 1.5
  // seconds instead of the theme's 3; an error stays the theme's 3 seconds, to be read.
  var $added = $form && $form.querySelector('.product-added-to-cart');
  if ($added && 'MutationObserver' in window) {
    var addedTimer = null;
    new MutationObserver(function () {
      var text = $added.textContent.trim();
      var ok = !!text && text === (window.theme && theme.strings && theme.strings.addedToCart);
      $added.classList.toggle('is-added', ok);
      clearTimeout(addedTimer);
      if (ok) {
        addedTimer = setTimeout(function () {
          $added.innerHTML = '';
        }, 1500);
      }
    }).observe($added, { childList: true, characterData: true, subtree: true });
  }

  // the page's own buy button does the adding (the theme's cart code, then the offer popup); false when it can't
  function addToCart() {
    var $atc = $form && $form.querySelector('[data-add-to-cart]');
    if (!$atc || $atc.disabled) return false;
    $atc.click();
    return true;
  }

  /* ---------------------------------------------------------------------------------------------
     PR.6 sticky buy bar
  --------------------------------------------------------------------------------------------- */

  var buyInView = true;

  function cartIsOpen() {
    return !!document.querySelector('#CartDrawer.drawer--is-open');
  }

  function syncSticky() {
    if (!$sticky) return;
    // a sheet covers the bar; the size dropdown opened from the bar (from 769px) hangs in it
    var dropUp = !!$dropHost && $dropHost === $sticky;
    var on = !buyInView && (!openName || dropUp) && !cartIsOpen();
    // the bar goes (the page's buy button came into view): its dropdown goes with it
    if (dropUp && !on) {
      closeSheet(false, true);
      return;
    }
    $sticky.classList.toggle('is-visible', on);
    $sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
    $stickyButtons.forEach(function ($button) {
      $button.tabIndex = on ? 0 : -1;
    });
    root.classList.toggle('pdp-sticky-on', on);
  }

  function renderSticky() {
    if (!$sticky) return;
    var $size = $sticky.querySelector('[data-pdp-sticky-size]');
    var $buy = $sticky.querySelector('[data-pdp-sticky-buy]');

    if ($size && current) {
      if (sizeList && !picked) {
        $size.textContent = config.chooseSize;
        $size.classList.add('is-pick');
      } else {
        $size.textContent = config.sizeShort + ' ' + current.title + (isPreorder(current) ? ' · ' + config.preorderShort.toLowerCase() : '');
        $size.classList.remove('is-pick');
      }
    }

    if ($buy) {
      if (!current || (picked && !current.available)) {
        $buy.textContent = config.soldOut;
      } else {
        var label = picked && isPreorder(current) ? config.preorderButton : config.addToCart;
        $buy.textContent = label + ' · ' + money(current.price);
      }
    }
  }

  if ($sticky && $form) {
    var $buyArea = $form.querySelector('.product-add-to-cart') || $form;

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        buyInView = entries[entries.length - 1].isIntersecting;
        syncSticky();
      }, { rootMargin: '-60px 0px 0px 0px' }).observe($buyArea);
    }

    // the bar steps aside while the cart drawer is open
    var $drawer = document.querySelector('#CartDrawer');
    if ($drawer && 'MutationObserver' in window) {
      new MutationObserver(syncSticky).observe($drawer, { attributes: true, attributeFilter: ['class'] });
    }

    $sticky.querySelector('[data-pdp-sticky-buy]').addEventListener('click', function () {
      var $button = this;
      if (sizeList && (!picked || !current || !current.available)) {
        // the dropdown it opened: closed again; one opened from the size line moves over to this button
        if ($dropHost && $opener === $button) {
          closeSheet();
          return;
        }
        openSheet('size', $button);
        addAfterPick = true;
        return;
      }
      if (!addToCart()) $buyArea.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  /* ---------------------------------------------------------------------------------------------
     PR.7 offer popup, before the cart drawer
  --------------------------------------------------------------------------------------------- */

  // the same cart triggers as eventAddToCart in assets/theme-custom.js. A moment later, not during the click that
  // asked for it: the theme closes its drawer on any click outside it, and that same click would close it again.
  // Without a drawer (the theme set to a cart page) nothing more happens: /cart sends back to /?open_cart=true
  // (handleCartRedirect in assets/theme-custom.js), which clicks the cart icon again, round and round.
  function openCart() {
    setTimeout(function () {
      var $drawer = document.querySelector('#CartDrawer');
      if (!$drawer || $drawer.classList.contains('drawer--is-open')) return;

      var triggers = ['.js-drawer-open-cart', '[aria-controls="CartDrawer"]', '.site-header__cart', '.cart-link'];
      for (var i = 0; i < triggers.length; i++) {
        var $trigger = document.querySelector(triggers[i]);
        if ($trigger) {
          $trigger.click();
          return;
        }
      }
    }, 150);
  }

  var added = null;
  var offerTotal = 0;

  function renderOfferTotal() {
    var $total = $offer.querySelector('[data-pdp-offer-total]');
    if ($total) $total.textContent = money(offerTotal);
  }

  // the offer's size follows the size just added, as the inline upsells do (productInlineUpsellsAutoSelector)
  function matchSize($select, size) {
    if (!$select || !size) return;
    var short = size.split('/')[0];
    var options = $select.querySelectorAll('option');
    for (var i = 0; i < options.length; i++) {
      var name = options[i].dataset.name || '';
      if (name === size || name === short || name.indexOf(short + '/') !== -1 || name.indexOf('/' + short) !== -1) {
        $select.value = options[i].value;
        return;
      }
    }
  }

  function resetOffer($item, size) {
    var $yes = $item.querySelector('[data-pdp-offer-yes]');
    var $select = $item.querySelector('[data-pdp-offer-variant]');
    if (!$yes.dataset.text) $yes.dataset.text = $yes.textContent;
    $yes.textContent = $yes.dataset.text;
    $yes.classList.remove('is-done');
    $yes.disabled = false;
    if ($select) {
      $select.disabled = false;
      matchSize($select, size);
    }
  }

  function openOffer() {
    var cartUrl = (window.theme && theme.routes && theme.routes.cart) || '/cart.js';
    fetch(cartUrl, { credentials: 'same-origin' })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var inCart = {};
        (cart.items || []).forEach(function (item) { inCart[item.product_id] = true; });

        var variant = byId(added && added.id) || current;
        var size = variant && variant.title !== 'Default Title' ? variant.title : '';
        // two different products first; the same product in another colour only to fill up
        var $items = Array.prototype.slice.call($offer.querySelectorAll('[data-pdp-offer]'));
        var $free = $items.filter(function ($item) { return !inCart[$item.dataset.productId]; });
        var groups = {};
        var $pick = [];
        $free.forEach(function ($item) {
          if ($pick.length < 2 && !groups[$item.dataset.group]) {
            groups[$item.dataset.group] = true;
            $pick.push($item);
          }
        });
        $free.forEach(function ($item) {
          if ($pick.length < 2 && $pick.indexOf($item) === -1) $pick.push($item);
        });

        var shown = $pick.length;
        $items.forEach(function ($item) {
          var show = $pick.indexOf($item) !== -1;
          $item.hidden = !show;
          if (show) resetOffer($item, size);
        });

        // nothing left to offer: the cart opens, as before
        if (!shown || !variant) {
          openCart();
          return;
        }

        var qty = (added && added.qty) || 1;
        offerTotal = variant.price * qty;
        $offer.querySelector('[data-pdp-added-line]').textContent =
          (size ? size + ' · ' : '') + (qty > 1 ? qty + ' × ' : '') + money(variant.price);

        var $image = $offer.querySelector('[data-pdp-added-image]');
        var src = variant.featured_image && variant.featured_image.src;
        if (!src && $section.dataset.imgUrl) src = $section.dataset.imgUrl.replace('{width}', '120');
        if ($image && src) {
          $image.src = src;
          $image.hidden = false;
        }

        renderOfferTotal();
        openSheet('offer');
      })
      .catch(openCart);
  }

  function addOffer($yes) {
    if ($yes.disabled || $yes.classList.contains('is-done')) return;
    var $item = $yes.closest('[data-pdp-offer]');
    var $select = $item.querySelector('[data-pdp-offer-variant]');
    var $option = $select && $select.options[$select.selectedIndex];
    if (!$option) return;

    $yes.disabled = true;
    var addUrl = (window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js';
    fetch(addUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'xmlhttprequest' },
      body: JSON.stringify({
        items: [{
          id: Number($option.value),
          quantity: 1,
          properties: { _upsell: 'true', _offer_type: 'pdp_offer_popup' }
        }]
      })
    })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        if (data.status) throw new Error(data.description || data.message);
        $yes.classList.add('is-done');
        $yes.textContent = $offer.dataset.textDone || $yes.dataset.text;
        $select.disabled = true;
        offerTotal += Number($option.dataset.price) || 0;
        renderOfferTotal();
        document.dispatchEvent(new Event('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:updated'));
      })
      .catch(function () {
        $yes.textContent = config.cannotAdd || $yes.dataset.text;
        setTimeout(function () {
          $yes.textContent = $yes.dataset.text;
          $yes.disabled = false;
        }, 2500);
      });
  }

  if ($offer && $form) {
    $offer.addEventListener('click', function (e) {
      var $yes = e.target.closest('[data-pdp-offer-yes]');
      if ($yes) {
        addOffer($yes);
      } else if (e.target.closest('[data-pdp-offer-to-cart]') || e.target.closest('[data-pdp-offer-close]')) {
        closeSheet();
        openCart();
      } else if (e.target.closest('[data-pdp-offer-shop]')) {
        // the product is in the cart; the customer stays where she was
        closeSheet();
      }
    });

    // called by eventAddToCart (assets/theme-custom.js) after a successful add
    window.pdpOfferPopup = {
      wants: function ($addForm) {
        if ($addForm !== $form || !$offer.querySelector('[data-pdp-offer]')) return false;
        var $id = $addForm.querySelector('[name="id"]');
        var $qty = $addForm.querySelector('[name="quantity"]');
        added = {
          id: $id ? $id.value : (current && current.id),
          qty: $qty ? Number($qty.value) || 1 : 1
        };
        return true;
      },
      open: openOffer
    };
  }

  /* --------------------------------------------------------------------------------------------- */

  function render() {
    if (sizeList) renderSize();
    renderSticky();
  }

  // keep up with the theme's size changes (also its own buttons on products without the size field)
  document.addEventListener('variant:change', function (e) {
    var variant = e.detail && e.detail.variant ? byId(e.detail.variant.id) : null;
    if (!variant) return;
    current = variant;
    render();
  });

  render();
  syncSticky();
})();
